<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <!-- Header section removed to declutter the page -->

      <!-- Tabs -->
      <div class="ibox float-e-margins mt-3">
        <div
          class="ibox-title"
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
          >
          <ul class="nav nav-tabs mb-0" style="border-bottom: none">
            <li class="nav-item">
              <a
                class="nav-link"
                [class.active]="activeTab() === 'definitions'"
                (click)="setActiveTab('definitions')"
                style="cursor: pointer"
                >
                Definitions
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                [class.active]="activeTab() === 'execute'"
                (click)="setActiveTab('execute')"
                style="cursor: pointer"
                >
                Execute
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                [class.active]="activeTab() === 'history'"
                (click)="setActiveTab('history')"
                style="cursor: pointer"
                >
                History
              </a>
            </li>
          </ul>
          <div class="d-flex align-items-center">
            <button
              class="btn btn-warning btn-sm"
              style="margin-right: 1.5rem;"
              (click)="restoreDatabase()"
              [disabled]="isRestoringDatabase() || currentExecution()?.status === 'Running'"
              title="Restore vNext database from dacpac (drops and recreates fresh database)"
              >
              <i class="fa" [ngClass]="isRestoringDatabase() ? 'fa-spinner fa-spin' : 'fa-database'"></i>
              {{ isRestoringDatabase() ? 'Restoring...' : 'Restore DB' }}
            </button>
            <span
              class="badge"
              [class.bg-success]="simulatorStatus() === 'online'"
              [class.bg-secondary]="simulatorStatus() === 'unknown'"
              [class.bg-danger]="simulatorStatus() === 'offline'"
              title="Simulator status"
              >
              {{ simulatorStatus() }}
            </span>
            <button
              class="btn btn-link btn-sm ms-2 p-0"
              (click)="refreshStatus()"
              [disabled]="checkingStatus()"
              >
              {{ checkingStatus() ? "Checking…" : "Refresh" }}
            </button>
          </div>
        </div>
        <div class="ibox-content">
          <!-- Definitions Tab -->
          @if (activeTab() === 'definitions') {
            <div>
              <div class="d-flex justify-content-between align-items-center mb-3">
                <button
                  class="btn btn-primary"
                  (click)="createNewDefinition()"
                  [disabled]="simulatorStatus() !== 'online' || !activeTournamentId()"
                  [title]="!activeTournamentId() ? 'An active tournament is required' : simulatorStatus() !== 'online' ? 'Simulator is offline' : 'Create a new simulation definition'"
                  >
                  <i class="fa fa-plus"></i> Create New Definition
                </button>
              </div>
              @if (simulatorStatus() !== 'online') {
                <div
                  class="alert alert-warning"
                  >
                  <strong>Simulator Offline:</strong> Cannot manage definitions
                  while Simulator is offline.
                </div>
              }
              @if (simulatorStatus() === 'online' && !activeTournamentId()) {
                <div
                  class="alert alert-warning"
                  >
                  <strong>No Active Tournament:</strong> An active tournament is required to create simulation definitions.
                </div>
              }
              @if (simulatorStatus() === 'online' && activeTournamentId()) {
                <div>
                  @if (definitions().length === 0) {
                    <div class="alert alert-info">
                      No simulation definitions found. Create one to get started.
                    </div>
                  }
                  @if (definitions().length > 0) {
                    <table
                      class="table table-striped"
                      >
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Type</th>
                          <th>Profile</th>
                          <th>Tournament</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (def of definitions(); track def) {
                          <tr
                            [class.table-active]="selectedDefinition()?.id === def.id"
                            >
                            <td>{{ def.name }}</td>
                            <td>
                              <span
                                class="badge"
                                [class.bg-info]="def.useMockTournament"
                                [class.bg-primary]="!def.useMockTournament"
                                >
                                {{ def.useMockTournament ? "Mock" : "Legacy Replay" }}
                              </span>
                            </td>
                            <td>
                              {{ def.profileName || "—" }}
                            </td>
                            <td>
                              {{ def.vNextTournamentId || def.sourceTournamentId }}
                            </td>
                            <td>
                              <div class="btn-group btn-group-spaced" role="group">
                                <button
                                  class="btn btn-sm btn-warning"
                                  (click)="editDefinition(def)"
                                  >
                                  <i class="fa fa-pencil"></i> Edit
                                </button>
                                <button
                                  class="btn btn-sm btn-success"
                                  (click)="openExecuteModal(def.id)"
                          [disabled]="
                            isExecutionRunning() ||
                            simulatorStatus() !== 'online'
                          "
                                  >
                                  <i class="fa fa-play"></i> Execute
                                </button>
                                <button
                                  class="btn btn-sm btn-info"
                                  (click)="openDryRunModal(def.id)"
                          [disabled]="
                            isExecutionRunning() ||
                            simulatorStatus() !== 'online'
                          "
                                  >
                                  <i class="fa fa-flask"></i> Dry Run
                                </button>
                                <button
                                  class="btn btn-sm btn-danger"
                                  (click)="deleteDefinition(def.id)"
                                  >
                                  <i class="fa fa-trash"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  }
                </div>
              }
              <!-- Definition Modal -->
              @if (isDefinitionModalOpen()) {
                <div
                  class="sim-modal-backdrop"
                  (click)="cancelDefinitionForm()"
                ></div>
              }
              @if (isDefinitionModalOpen()) {
                <div
                  class="sim-modal"
                  tabindex="-1"
                  role="dialog"
                  aria-modal="true"
                  aria-labelledby="definitionModalTitle"
                  >
                  <div class="modal-dialog modal-xl">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h3 class="modal-title mb-0" id="definitionModalTitle">
                          {{
                          isEditingDefinition()
                          ? "Edit Definition"
                          : "Create Definition"
                          }}
                        </h3>
                        @if (activeTournamentName()) {
                          <div
                            class="ms-3 text-muted"
                            >
                            Active tournament:
                            <strong>{{ activeTournamentName() }}</strong>
                          </div>
                        } @else {
                          <div class="ms-3 text-warning small">
                            No active tournament detected
                          </div>
                        }
                        <button
                          type="button"
                          class="btn-close"
                          aria-label="Close"
                          (click)="cancelDefinitionForm()"
                        ></button>
                      </div>
                      <div class="modal-body">
                        @if (formError()) {
                          <div class="alert alert-danger">
                            {{ formError() }}
                          </div>
                        }
                        <form>
                          <div class="row">
                            <div class="col-md-6 mb-3">
                              <label class="form-label">Name *</label>
                              <input
                                class="form-control"
                                [ngModel]="definitionForm().name"
                                (ngModelChange)="updateForm({ name: $event })"
                                name="name"
                                />
                              </div>
                              <div class="col-md-6 mb-3">
                                <label class="form-label">
                                  Profile
                                  @if (selectedProfile(); as profile) {
                                    <i
                                      class="fa fa-info-circle text-info ms-2"
                                      style="cursor: help; font-size: 1.1em;"
                              [title]="'Mode: ' + (profile.isValidationMode ? 'Validation' : 'Full Execution') + '\n' +
                                       'Duration: ' + (profile.typicalDuration || 'N/A') + '\n' +
                                       'Throughput: ' + (profile.timing?.requestsPerSecond === 2147483647 ? 'Max' : (profile.timing?.requestsPerSecond || 0) + ' req/sec') + '\n' +
                                       'Speedup: ' + (profile.timing?.approximateSpeedup === 1 ? 'Real-time' : (profile.timing?.approximateSpeedup || 'N/A') + 'x')"
                                    ></i>
                                  }
                                </label>
                                <select
                                  class="form-control"
                                  [ngModel]="definitionForm().profileName"
                            (ngModelChange)="
                              updateForm({ profileName: $event })
                            "
                                  name="profileName"
                                  >
                                  <option [ngValue]="''" disabled>
                                    -- Select a Profile --
                                  </option>
                                  @for (p of filteredProfiles(); track p) {
                                    <option
                                      [ngValue]="p.name"
                                      >
                                      {{ p.name }}
                                    </option>
                                  }
                                </select>
                                @if (
                                  definitionForm().profileName) {
                                  @if (selectedProfile(); as sp) {
                                    <div
                                      class="form-text text-muted small mt-1 mb-3"
                                      >
                                      {{ sp.description }}
                                    </div>
                                  }
                                } @else {
                                  <small class="text-danger"
                                    >Profile is required.</small
                                    >
                                  }
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-12 mb-4">
                                  <label class="form-label">Description</label>
                                  <textarea
                                    class="form-control"
                                    rows="2"
                                    [ngModel]="definitionForm().description"
                            (ngModelChange)="
                              updateForm({ description: $event })
                            "
                                    name="description"
                                  ></textarea>
                                </div>
                              </div>
                              <!-- Simulation Mode Selection -->
                              <div class="row">
                                <div class="col-md-12 mb-4">
                                  <label class="form-label">Simulation Mode *</label>
                                  <div class="btn-group d-flex" role="group">
                                    <input
                                      type="radio"
                                      class="btn-check"
                                      name="simulationMode"
                                      id="legacyReplayMode"
                                      [checked]="!definitionForm().useMockTournament"
                                      (change)="updateForm({ useMockTournament: false })"
                                      />
                                      <label class="btn btn-outline-primary" for="legacyReplayMode">
                                        <i class="fa fa-database me-2"></i>Legacy Replay
                                      </label>
                                      <input
                                        type="radio"
                                        class="btn-check"
                                        name="simulationMode"
                                        id="mockTournamentMode"
                                        [checked]="definitionForm().useMockTournament"
                                        (change)="updateForm({ useMockTournament: true })"
                                        />
                                        <label class="btn btn-outline-success" for="mockTournamentMode">
                                          <i class="fa fa-lightbulb-o me-2"></i>Mock Tournament
                                        </label>
                                      </div>
                                      <div class="form-text text-muted small mt-2">
                                        <strong>Legacy Replay:</strong> Replays actual tournament data from legacy database.
                                        <strong>Mock Tournament:</strong> Generates realistic synthetic scoring data.
                                      </div>
                                    </div>
                                  </div>
                                  <!-- Mock Tournament Configuration -->
                                  @if (definitionForm().useMockTournament) {
                                    <div
                                      class="mock-config-section mb-4"
                                      >
                                      <div class="alert alert-success">
                                        <i class="fa fa-lightbulb-o me-2"></i>
                                        <strong>Mock Tournament Mode</strong>
                                        <p class="mb-2 mt-2">
                                          Generates realistic synthetic scores and shots for the active tournament.
                                        </p>
                                      </div>
                                      <div class="row">
                                        <div class="col-md-12 mb-3">
                                          <label class="form-label">
                                            <i class="fa fa-trophy me-1"></i>vNext Tournament ID *
                                          </label>
                                          <input
                                            type="text"
                                            class="form-control"
                                            [ngModel]="definitionForm().vNextTournamentId"
                                            (ngModelChange)="updateForm({ vNextTournamentId: $event })"
                                            name="vNextTournamentId"
                                            placeholder="Enter vNext Tournament GUID"
                                            [readonly]="!!activeTournamentId()"
                                            [class.auto-filled]="!!activeTournamentId()"
                                            />
                                            @if (activeTournamentId()) {
                                              <div class="form-text text-muted small mt-1">
                                                Auto-populated from active tournament
                                              </div>
                                            }
                                            @if (!activeTournamentId()) {
                                              <div class="form-text text-muted small mt-1">
                                                Tournament GUID from vNext API where scores will be submitted
                                              </div>
                                            }
                                          </div>
                                        </div>
                                        <div class="row">
                                          <div class="col-md-6 mb-3">
                                            <label class="form-label">
                                              <i class="fa fa-random me-1"></i>Seed (Optional)
                                            </label>
                                            <input
                                              type="number"
                                              class="form-control"
                                              min="1"
                                              max="99"
                                              [ngModel]="definitionForm().seed"
                                              (ngModelChange)="updateForm({ seed: $event || null })"
                                              name="mockSeed"
                                              placeholder="1-99 (leave blank for random)"
                                              />
                                              <div class="form-text text-muted small mt-1">
                                                Same seed generates identical scores for reproducibility
                                              </div>
                                            </div>
                                          </div>
                                          <div class="alert alert-info mb-0">
                                            <ul class="mb-0">
                                              <li>Uses existing tournament setup (course, players, groups)</li>
                                              <li>Perfect for testing without legacy database dependencies</li>
                                              <li>Supports resume - interrupted simulations can be safely restarted</li>
                                            </ul>
                                          </div>
                                        </div>
                                      }
                                      <!-- Legacy Replay Template Section -->
                                      @if (!definitionForm().useMockTournament) {
                                        <div
                                          class="template-section mt-3 mb-4"
                                          [class.collapsed]="isLegacySectionCollapsed()"
                                          >
                                          <div class="section-header mb-3 collapsible-header" (click)="isLegacySectionCollapsed.set(!isLegacySectionCollapsed())">
                                            <div class="header-content">
                                              <h6 class="mb-0">
                                                <i class="fa fa-database me-2"></i>Legacy Tournament
                                                Setup
                                                <i
                                                  class="fa fa-info-circle text-warning ms-2"
                                                  style="cursor: help; font-size: 1.1em;"
                                                  title="Replays scoring from an actual legacy tournament database. Select a Tournament Template to auto-populate connection details. Requires legacy database credentials (user/password). Scores and shots are replayed in order through the vNext API."
                                                  (click)="$event.stopPropagation()"
                                                ></i>
                                              </h6>
                                              <small class="text-muted"
                                                >Select a Legacy Tournament to Replay</small
                                                >
                                            </div>
                                            <i class="fa collapse-icon" [ngClass]="isLegacySectionCollapsed() ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                                            </div>
                                          <div class="section-content" [class.hidden]="isLegacySectionCollapsed()">
                                            <div class="row">
                                              <div class="col-md-12 mb-3">
                                                <app-legacy-replay-template-selector
                              [selectedTemplateId]="
                                selectedLegacyTemplate()?.id || ''
                              "
                              (templateSelected)="
                                onLegacyTemplateSelected($event)
                              "
                                                ></app-legacy-replay-template-selector>
                                              </div>
                                            </div>
                                            <!-- Auto-populated fields from template -->
                                            @if (selectedLegacyTemplate()) {
                                              <div
                                                class="auto-populated-fields mb-3"
                                                >
                                                <div
                                                  class="alert alert-info d-flex align-items-center mb-3"
                                                  >
                                                  <i class="fa fa-check-circle me-2"></i>
                                                  <span
                                                    >Fields auto-populated from template. Server and database can be overridden for your environment.</span
                                                    >
                                                  </div>
                                                  <div class="row">
                                                    <div class="col-md-6 col-lg-4 mb-3">
                                                      <label class="form-label">
                                                        <i class="fa fa-hashtag me-1"></i>Legacy
                                                        Tournament Id *
                                                      </label>
                                                      <div class="input-group">
                                                        <input
                                                          class="form-control auto-filled"
                                                          [ngModel]="definitionForm().sourceTournamentId"
                                                          readonly
                                                          name="sourceTournamentId"
                                                          [class.is-valid]="legacyConnectionStatus() === 'connected'"
                                                          [class.is-invalid]="legacyConnectionStatus() === 'failed'"
                                                          />
                                                        <button
                                                          type="button"
                                                          class="btn"
                                                          [ngClass]="{
                                                            'btn-outline-secondary': legacyConnectionStatus() === 'idle' || legacyConnectionStatus() === 'loading',
                                                            'btn-outline-success': legacyConnectionStatus() === 'connected',
                                                            'btn-outline-danger': legacyConnectionStatus() === 'failed'
                                                          }"
                                                          (click)="refreshTournamentId()"
                                                          [disabled]="isLoadingTournamentId"
                                                          title="Refresh Tournament ID from legacy database"
                                                          >
                                                          <i class="fa" [ngClass]="{
                                                            'fa-spinner fa-spin': legacyConnectionStatus() === 'loading',
                                                            'fa-check': legacyConnectionStatus() === 'connected',
                                                            'fa-times': legacyConnectionStatus() === 'failed',
                                                            'fa-refresh': legacyConnectionStatus() === 'idle'
                                                          }"></i>
                                                        </button>
                                                      </div>
                                                      @if (legacyConnectionStatus() === 'connected') {
                                                        <small class="text-success mt-1 d-block">
                                                          <i class="fa fa-check-circle me-1"></i>Connected successfully
                                                        </small>
                                                      }
                                                      @if (legacyConnectionStatus() === 'failed') {
                                                        <small class="text-danger mt-1 d-block">
                                                          <i class="fa fa-exclamation-circle me-1"></i>{{ legacyConnectionError() || 'Connection failed' }}
                                                        </small>
                                                      }
                                                      </div>
                                                      <div class="col-md-6 col-lg-3 mb-3">
                                                        <label class="form-label">
                                                          <i class="fa fa-server me-1"></i>Legacy Server *
                                                        </label>
                                                        <input
                                                          class="form-control"
                                                          [ngModel]="definitionForm().legacyServer"
                                                          (ngModelChange)="updateForm({ legacyServer: $event })"
                                                          name="legacyServer"
                                                          placeholder="e.g., localhost,5433"
                                                          />
                                                        </div>
                                                        <div class="col-md-12 col-lg-5 mb-3">
                                                          <label class="form-label">
                                                            <i class="fa fa-database me-1"></i>Legacy
                                                            Database *
                                                          </label>
                                                          <input
                                                            class="form-control"
                                                            [ngModel]="definitionForm().legacyDatabase"
                                                            (ngModelChange)="updateForm({ legacyDatabase: $event })"
                                                            name="legacyDatabase"
                                                            placeholder="e.g., LPGA_Scoring_Site_2025_33_CME"
                                                            />
                                                          </div>
                                                        </div>
                                                      </div>
                                                    }
                                                    <!-- Manual entry fields (always editable) -->
                                                    <div class="manual-fields mt-3">
                                                      <div class="row">
                                                        <div class="col-md-6 mb-3">
                                                          <label class="form-label">
                                                            <i class="fa fa-user me-1"></i>Legacy User *
                                                          </label>
                                                          <input
                                                            class="form-control"
                                                            [ngModel]="definitionForm().legacyUserId"
                                (ngModelChange)="
                                  updateForm({ legacyUserId: $event })
                                "
                                                            name="legacyUserId"
                                                            placeholder="Enter database username"
                                                            />
                                                          </div>
                                                          <div class="col-md-6 mb-3">
                                                            <label class="form-label">
                                                              <i class="fa fa-lock me-1"></i>Legacy Password *
                                                            </label>
                                                            <input
                                                              type="password"
                                                              class="form-control"
                                                              [ngModel]="definitionForm().legacyPassword"
                                (ngModelChange)="
                                  updateForm({ legacyPassword: $event })
                                "
                                                              name="legacyPassword"
                                                              placeholder="Enter database password"
                                                              />
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div><!-- end section-content -->
                                                    </div><!-- end template-section -->
                                                    }
                                                    <!-- Seed field now part of Mock Config Section above -->
                                                    <!-- Continuous Execution Section -->
                                                    <div class="continuous-execution-section" [class.collapsed]="isContinuousSectionCollapsed()">
                                                      <div class="section-header collapsible-header" (click)="isContinuousSectionCollapsed.set(!isContinuousSectionCollapsed())">
                                                        <div class="header-content">
                                                          <h6>
                                                            <i class="fa fa-repeat me-2"></i>Continuous Execution
                                                            <i
                                                              class="fa fa-info-circle text-warning ms-2"
                                                              title="Enable continuous execution to automatically process all rounds without operator intervention. The Simulator will close rounds, mark scorecards official, and activate the next round automatically."
                                                              (click)="$event.stopPropagation()"
                                                            ></i>
                                                          </h6>
                                                          <small class="text-muted">Run through all tournament rounds without pausing</small>
                                                        </div>
                                                        <i class="fa collapse-icon" [ngClass]="isContinuousSectionCollapsed() ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                                                      </div>
                                                      <div class="section-content" [class.hidden]="isContinuousSectionCollapsed()">
                                                      <div class="form-check mb-2">
                                                        <input
                                                          type="checkbox"
                                                          class="form-check-input"
                                                          id="continuousExecution"
                                                          [ngModel]="definitionForm().continuousExecution"
                                                          (ngModelChange)="updateForm({ continuousExecution: $event })"
                                                          name="continuousExecution"
                                                          />
                                                          <label class="form-check-label" for="continuousExecution">
                                                            <strong>Enable Continuous Execution</strong>
                                                            <small class="text-muted ms-2">Auto-close rounds, mark official, activate next</small>
                                                          </label>
                                                        </div>
                                                        <!-- Continuous execution sub-options (only show when enabled) -->
                                                        @if (definitionForm().continuousExecution) {
                                                          <div class="continuous-execution-options compact">
                                                            <div class="options-row">
                                                              <div class="option-item">
                                                                <div class="form-check form-check-inline">
                                                                  <input
                                                                    type="checkbox"
                                                                    class="form-check-input"
                                                                    id="autoCloseRounds"
                                                                    [ngModel]="definitionForm().autoCloseRounds !== false"
                                                                    (ngModelChange)="updateForm({ autoCloseRounds: $event })"
                                                                    name="autoCloseRounds"
                                                                    />
                                                                    <label class="form-check-label" for="autoCloseRounds" title="Automatically close rounds after scoring completes">
                                                                      Auto-close rounds
                                                                    </label>
                                                                  </div>
                                                                </div>
                                                                <div class="option-item">
                                                                  <div class="form-check form-check-inline">
                                                                    <input
                                                                      type="checkbox"
                                                                      class="form-check-input"
                                                                      id="autoMarkOfficial"
                                                                      [ngModel]="definitionForm().autoMarkOfficial !== false"
                                                                      (ngModelChange)="updateForm({ autoMarkOfficial: $event })"
                                                                      name="autoMarkOfficial"
                                                                      />
                                                                      <label class="form-check-label" for="autoMarkOfficial" title="Mark all scorecards official before closing round">
                                                                        Auto-mark official
                                                                      </label>
                                                                    </div>
                                                                  </div>
                                                                  <div class="option-item">
                                                                    <div class="form-check form-check-inline">
                                                                      <input
                                                                        type="checkbox"
                                                                        class="form-check-input"
                                                                        id="skipRoundValidation"
                                                                        [ngModel]="definitionForm().skipRoundValidation === true"
                                                                        (ngModelChange)="updateForm({ skipRoundValidation: $event })"
                                                                        name="skipRoundValidation"
                                                                        />
                                                                        <label class="form-check-label" for="skipRoundValidation" title="Don't validate scores at the end of each round">
                                                                          Skip validation
                                                                        </label>
                                                                      </div>
                                                                    </div>
                                                                    <div class="option-item delay-input">
                                                                      <label class="form-label mb-0 me-2" for="transitionDelaySeconds">
                                                                        <i class="fa fa-clock-o"></i> Delay:
                                                                      </label>
                                                                      <input
                                                                        type="number"
                                                                        class="form-control form-control-sm"
                                                                        id="transitionDelaySeconds"
                                                                        [ngModel]="definitionForm().transitionDelaySeconds || 30"
                                                                        (ngModelChange)="updateForm({ transitionDelaySeconds: $event })"
                                                                        name="transitionDelaySeconds"
                                                                        min="0"
                                                                        max="300"
                                                                        placeholder="30"
                                                                        style="width: 70px;"
                                                                        />
                                                                        <small class="text-muted ms-1">sec</small>
                                                                    </div>
                                                                  </div>
                                                                  <div class="alert alert-warning compact-warning mb-0 mt-2">
                                                                    <i class="fa fa-exclamation-triangle me-1"></i>
                                                                    <small>Continuous execution will automatically close rounds and mark scorecards official.</small>
                                                                  </div>
                                                                  </div>
                                                                }
                                                              </div><!-- end section-content -->
                                                              </div><!-- end continuous-execution-section -->
                                                              <!-- Profile-only mode trimmed: summary shown inline near the selector -->
                                                            </form>
                                                          </div>
                                                          <div class="modal-footer">
                                                            <button
                                                              type="button"
                                                              class="btn btn-default"
                                                              (click)="cancelDefinitionForm()"
                                                              >
                                                              Cancel
                                                            </button>
                                                            <button
                                                              type="button"
                                                              class="btn btn-primary"
                                                              (click)="saveDefinition()"
                                                              [disabled]="!definitionForm().profileName"
                                                              >
                                                              {{ isEditingDefinition() ? "Save Changes" : "Create" }}
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  }
                                                </div>
                                              }

                                              <!-- Execute Tab -->
                                              @if (activeTab() === 'execute') {
                                                <div>
                                                  @if (!currentExecution()) {
                                                    <div class="alert alert-info">
                                                      No active execution. Select a definition from the Definitions tab
                                                      and click Execute.
                                                    </div>
                                                  }
                                                  @if (currentExecution()) {
                                                    <div>
                                                      <!-- Dry Run Results -->
                                                      @if (
                                                        currentExecution()!.status === 'DryRunComplete' &&
                                                        currentExecution()!.dryRunResults
                                                        ) {
                                                        <div
                                                          class="mb-3"
                                                          >
                                                          <div class="card border-info">
                                                            <div class="card-header bg-info text-white">
                                                              <h5 class="mb-0">Dry Run Validation Results</h5>
                                                            </div>
                                                            <div class="card-body">
                                                              <p>
                                                                <strong>Overall:</strong>
                                                                <span
                                                                  class="badge"
                        [class.bg-success]="
                          currentExecution()!.dryRunResults!.isValid
                        "
                        [class.bg-danger]="
                          !currentExecution()!.dryRunResults!.isValid
                        "
                                                                  >
                                                                  {{
                                                                  currentExecution()!.dryRunResults!.isValid
                                                                  ? "Valid"
                                                                  : "Issues Found"
                                                                  }}
                                                                </span>
                                                              </p>
                                                              <div class="row">
                                                                @if (
                                                                  currentExecution()!.dryRunResults!
                                                                  .legacyDataValidation; as ldv
                                                                  ) {
                                                                  <div
                                                                    class="col-md-4"
                                                                    >
                                                                    <h6>Legacy Data</h6>
                                                                    <ul class="list-unstyled small">
                                                                      <li>Valid: {{ ldv.isValid }}</li>
                                                                      <li>Tournament Found: {{ ldv.tournamentFound }}</li>
                                                                      <li>Groups: {{ ldv.groupCount }}</li>
                                                                      <li>Scorecards: {{ ldv.scorecardCount }}</li>
                                                                      <li>Scores: {{ ldv.scoreCount }}</li>
                                                                      <li>Shots: {{ ldv.shotCount }}</li>
                                                                      @if (ldv.missingData.length) {
                                                                        <li>
                                                                          Missing: {{ ldv.missingData.length }}
                                                                        </li>
                                                                      }
                                                                    </ul>
                                                                  </div>
                                                                }
                                                                @if (
                                                                  currentExecution()!.dryRunResults!
                                                                  .vNextPrerequisitesValidation; as vpv
                                                                  ) {
                                                                  <div
                                                                    class="col-md-4"
                                                                    >
                                                                    <h6>vNext Prerequisites</h6>
                                                                    <ul class="list-unstyled small">
                                                                      <li>Valid: {{ vpv.isValid }}</li>
                                                                      <li>Tournament Exists: {{ vpv.tournamentExists }}</li>
                                                                      <li>Courses Exist: {{ vpv.coursesExist }}</li>
                                                                      <li>Players Exist: {{ vpv.playersExist }}</li>
                                                                      <li>Groups Exist: {{ vpv.groupsExist }}</li>
                                                                      <li>Missing Players: {{ vpv.missingPlayerCount }}</li>
                                                                    </ul>
                                                                  </div>
                                                                }
                                                                @if (
                                                                  currentExecution()!.dryRunResults!
                                                                  .apiConnectivityValidation; as api
                                                                  ) {
                                                                  <div
                                                                    class="col-md-4"
                                                                    >
                                                                    <h6>API Connectivity</h6>
                                                                    <ul class="list-unstyled small">
                                                                      <li>Valid: {{ api.isValid }}</li>
                                                                      <li>Reachable: {{ api.apiReachable }}</li>
                                                                      <li>Authenticated: {{ api.authenticated }}</li>
                                                                      <li>Response Time: {{ api.responseTimeMs }} ms</li>
                                                                    </ul>
                                                                  </div>
                                                                }
                                                              </div>
                                                              @if (
                                                                currentExecution()!.dryRunResults!.preview; as preview
                                                                ) {
                                                                <div
                                                                  >
                                                                  <h6 class="mt-3">
                                                                    Preview ({{ preview.previewScoreCount }})
                                                                  </h6>
                                                                  @if (preview.scores.length) {
                                                                    <div
                                                                      class="table-responsive"
                                                                      >
                                                                      <table class="table table-sm table-striped">
                                                                        <thead>
                                                                          <tr>
                                                                            <th>Player</th>
                                                                            <th>Round</th>
                                                                            <th>Hole</th>
                                                                            <th>Score</th>
                                                                            <th>Shots</th>
                                                                          </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                          @for (s of preview.scores; track s) {
                                                                            <tr>
                                                                              <td>{{ s.playerName }}</td>
                                                                              <td>{{ s.round }}</td>
                                                                              <td>{{ s.hole }}</td>
                                                                              <td>{{ s.score }}</td>
                                                                              <td>{{ s.shotCount }}</td>
                                                                            </tr>
                                                                          }
                                                                        </tbody>
                                                                      </table>
                                                                    </div>
                                                                  }
                                                                </div>
                                                              }
                                                              <div class="row mt-2">
                                                                @if (
                                                                  currentExecution()!.dryRunResults!.warnings.length
                                                                  ) {
                                                                  <div
                                                                    class="col-md-6"
                                                                    >
                                                                    <h6>
                                                                      Warnings ({{
                                                                      currentExecution()!.dryRunResults!.warnings.length
                                                                      }})
                                                                    </h6>
                                                                    <ul class="small">
                                                                      @for (
                                                                        w of currentExecution()!.dryRunResults!
                                                                        .warnings
                                                                        ; track
                                                                        w) {
                                                                        <li
                                                                          >
                                                                          {{ w }}
                                                                        </li>
                                                                      }
                                                                    </ul>
                                                                  </div>
                                                                }
                                                                @if (
                                                                  currentExecution()!.dryRunResults!.errors.length
                                                                  ) {
                                                                  <div
                                                                    class="col-md-6"
                                                                    >
                                                                    <h6>
                                                                      Errors ({{
                                                                      currentExecution()!.dryRunResults!.errors.length
                                                                      }})
                                                                    </h6>
                                                                    <ul class="small text-danger">
                                                                      @for (
                                                                        e of currentExecution()!.dryRunResults!.errors
                                                                        ; track
                                                                        e) {
                                                                        <li
                                                                          >
                                                                          {{ e }}
                                                                        </li>
                                                                      }
                                                                    </ul>
                                                                  </div>
                                                                }
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      }
                                                      <div class="row">
                                                        <div class="col-lg-6">
                                                          <div class="ibox execution-status-ibox">
                                                            <div class="ibox-title">
                                                              <h5>
                                                                Execution Status
                                                                <span
                                                                  class="badge ms-2"
                                                                  [class.bg-warning]="currentExecution()!.status === 'Pending'"
                                                                  [class.bg-primary]="currentExecution()!.status === 'Running'"
                                                                  [class.bg-secondary]="currentExecution()!.status === 'Paused'"
                                                                  [class.bg-success]="currentExecution()!.status === 'Completed'"
                                                                  [class.bg-danger]="currentExecution()!.status === 'Failed'"
                                                                  [class.bg-dark]="currentExecution()!.status === 'Stopped'"
                                                                  >
                                                                  {{ currentExecution()!.status }}
                                                                </span>
                                                              </h5>
                                                            </div>
                                                            <div class="ibox-content">
                                                              <div class="info-section">
                                                                <p class="m-b-sm"><strong>ID: </strong><span class="text-muted">{{ currentExecution()!.id }}</span></p>
                                                                <p class="m-b-sm">
                                                                  <strong>Definition: </strong>
                                                                  <span class="text-navy">{{ currentExecutionDefinitionName() || "Unknown" }}</span>
                                                                </p>
                                                                <p class="m-b-sm">
                                                                  <strong>Definition ID: </strong>
                                                                  <span class="text-muted">{{ currentExecution()!.definitionId }}</span>
                                                                </p>
                                                                <p class="m-b-sm">
                                                                  <strong>Started: </strong>
                                                                  <span class="text-muted">{{ formatLocalTime(currentExecution()!.startedAt) }}</span>
                                                                </p>
                                                                @if (currentExecution()!.completedAt) {
                                                                  <p class="m-b-sm">
                                                                    <strong>Completed: </strong>
                                                                    <span class="text-muted">{{ formatLocalTime(currentExecution()!.completedAt) }}</span>
                                                                  </p>
                                                                }
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div class="col-lg-6">
                                                          <div class="ibox within-round-ibox">
                                                            <div class="ibox-title">
                                                              <h5>Within-Round Progress</h5>
                                                            </div>
                                                            <div class="ibox-content">
                                                              @if (executionProgress()) {
                                                                <div>
                                                                  <div class="info-group">
                                                                    <p class="m-b-sm">
                                                                      <strong>Round:</strong>
                                                                      <span class="text-navy">{{ executionProgress()!.currentRound }}</span>
                                                                    </p>
                                                                    <p class="m-b-sm">
                                                                      <strong>Groups:</strong>
                                                                      <span class="text-muted">{{ executionProgress()!.completedGroups }} / {{ executionProgress()!.totalGroups }}</span>
                                                                    </p>
                                                                    <p class="m-b-sm">
                                                                      <strong>Scores:</strong>
                                                                      <span class="text-muted">{{ executionProgress()!.scoresSubmitted }} submitted, {{ executionProgress()!.scoresFailed }} failed</span>
                                                                    </p>
                                                                    <p class="m-b-sm">
                                                                      <strong>Shots:</strong>
                                                                      <span class="text-muted">{{ executionProgress()!.shotsSubmitted }}</span>
                                                                    </p>
                                                                  </div>
                                                                  @if (executionProgress()!.currentActivity) {
                                                                    <div class="info-group">
                                                                      <p class="m-b-sm">
                                                                        <strong>Activity:</strong>
                                                                        <span class="text-muted">{{ executionProgress()!.currentActivity }}</span>
                                                                      </p>
                                                                    </div>
                                                                  }
                                                                  <!-- Within-round progress bar (scores and shots) -->
                                                                  <div class="progress" style="height: 24px; position: relative;">
                                                                    <div
                                                                      class="progress-bar"
                                                                      [class.progress-bar-success]="currentExecution()!.status === 'Completed'"
                            [ngClass]="{
                              'progress-bar-info': currentExecution()!.status === 'Running' || currentExecution()!.status === 'Pending',
                              'progress-bar-warning': currentExecution()!.status === 'Paused',
                              'progress-bar-danger': currentExecution()!.status === 'Failed' || currentExecution()!.status === 'Stopped'
                            }"
                                                                      role="progressbar"
                                                                      [style.width.%]="executionProgress()!.progressPercentage"
                                                                      [attr.aria-valuenow]="executionProgress()!.progressPercentage"
                                                                      aria-valuemin="0"
                                                                      aria-valuemax="100"
                                                                      >
                                                                    </div>
                                                                    <div class="progress-text">
                                                                      {{ executionProgress()!.progressPercentage | number : '1.0-1' }}%
                                                                    </div>
                                                                  </div>
                                                                  <small class="text-muted d-block m-t-xs">
                                                                    Scores: {{ executionProgress()!.scoresSubmitted }} submitted, {{ executionProgress()!.scoresFailed }} failed · Shots: {{ executionProgress()!.shotsSubmitted }}
                                                                  </small>
                                                                  <div class="timing-section">
                                                                    <p class="m-b-sm">
                                                                      <strong>Elapsed:</strong>
                                                                      <span class="text-muted">{{ executionProgress()!.elapsedTime }}</span>
                                                                    </p>
                                                                    <!-- Estimated Completion hidden - not reliable yet -->
                                                                    <!-- <p class="m-b-sm" *ngIf="executionProgress()!.estimatedCompletionTime">
                                                                    <strong>Estimated Completion:</strong>
                                                                    {{ executionProgress()!.estimatedCompletionTime }}
                                                                  </p> -->
                                                                  @if (executionProgress()!.replayClock) {
                                                                    <p class="m-b-sm">
                                                                      <strong>Replay Clock:</strong>
                                                                      <span class="text-muted">{{ executionProgress()!.replayClock }}</span>
                                                                    </p>
                                                                  }
                                                                </div>
                                                              </div>
                                                            }
                                                            <div class="m-t-md">
                                                              <button
                                                                class="btn btn-sm btn-white"
                                                                (click)="refreshProgress()"
                                                                >
                                                                <i class="fa fa-refresh"></i> Refresh Progress
                                                              </button>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <!-- Control Buttons -->
                                                    <div class="btn-group mb-3" role="group">
                                                      <!-- Pause/Resume buttons hidden until functionality is verified
                                                      <button
                                                        class="btn btn-warning"
                                                        (click)="pauseExecution()"
                                                        [disabled]="currentExecution()!.status !== 'Running'"
                                                        title="Pause at next hole boundary"
                                                        >
                                                        <i class="fa fa-pause"></i> Pause
                                                      </button>
                                                      <button
                                                        class="btn btn-info"
                                                        (click)="resumeExecution()"
                                                        [disabled]="currentExecution()!.status !== 'Paused'"
                                                        title="Resume from paused state"
                                                        >
                                                        <i class="fa fa-play"></i> Resume
                                                      </button>
                                                      -->
                                                      <button
                                                        class="btn btn-danger"
                                                        (click)="stopExecution()"
                                                        [disabled]="currentExecution()!.status !== 'Running'"
                                                        title="Stop permanently (cannot be resumed)"
                                                        >
                                                        <i class="fa fa-stop"></i> Stop
                                                      </button>
                                                      <button
                                                        class="btn btn-info ms-2"
                                                        (click)="validateCurrentRound()"
                  [disabled]="
                    currentExecution()!.status !== 'Completed' &&
                    currentExecution()!.status !== 'Failed' &&
                    currentExecution()!.status !== 'Stopped'
                  "
                                                        title="Validate round completion (check for incomplete scores)"
                                                        >
                                                        <i class="fa fa-check-circle"></i> Validate Round
                                                      </button>
                                                      <button
                                                        class="btn btn-warning ms-2"
                                                        (click)="resetCurrentRound()"
                  [disabled]="
                    isResettingRound() ||
                    (currentExecution()!.status !== 'Completed' &&
                    currentExecution()!.status !== 'Failed' &&
                    currentExecution()!.status !== 'Stopped')
                  "
                                                        title="Reset round by deleting all scores and shots (allows replay)"
                                                        >
                                                        <i class="fa" [ngClass]="isResettingRound() ? 'fa-spinner fa-spin' : 'fa-refresh'"></i>
                                                        {{ isResettingRound() ? 'Resetting Round...' : 'Reset Round' }}
                                                      </button>
                                                      <button
                                                        class="btn btn-secondary ms-2"
                                                        (click)="viewExecutionSummary(currentExecution()!.id)"
                  [disabled]="
                    currentExecution()!.status !== 'Completed' &&
                    currentExecution()!.status !== 'Failed' &&
                    currentExecution()!.status !== 'Stopped'
                  "
                                                        >
                                                        <i class="fa fa-file-text-o"></i> View Summary
                                                      </button>
                                                    </div>
                                                    <!-- Errors/Warnings -->
                                                    @if (executionProgress()?.errorMessage) {
                                                      <div
                                                        class="alert alert-danger"
                                                        >
                                                        <h5>Error</h5>
                                                        <p>{{ executionProgress()!.errorMessage }}</p>
                                                      </div>
                                                    }
                                                    @if (
                                                      executionProgress()?.failedRequests &&
                                                      executionProgress()!.failedRequests > 0
                                                      ) {
                                                      <div
                                                        class="alert alert-warning"
                                                        >
                                                        <h5>Failed Requests</h5>
                                                        <p>
                                                          <strong>Failed:</strong>
                                                          {{ executionProgress()!.failedRequests }} /
                                                          {{
                                                          executionProgress()!.successfulRequests +
                                                          executionProgress()!.failedRequests
                                                          }}
                                                          total
                                                        </p>
                                                      </div>
                                                    }
                                                    @if (
                                                      executionProgress()?.lastRoundValidation &&
                                                      !executionProgress()!.lastRoundValidation!.isValid
                                                      ) {
                                                      <div
                                                        class="alert alert-warning"
                                                        >
                                                        <h5><i class="fa fa-exclamation-triangle"></i> Round Validation Issue</h5>
                                                        <p>{{ executionProgress()!.lastRoundValidation!.validationMessage }}</p>
                                                        @if (executionProgress()!.lastRoundValidation!.incompleteScoreDetails.length > 0) {
                                                          <div class="m-t-sm">
                                                            <strong>Incomplete Scores:</strong>
                                                            <ul class="m-t-xs">
                                                              @for (detail of executionProgress()!.lastRoundValidation!.incompleteScoreDetails; track detail) {
                                                                <li>
                                                                  Player {{ detail.playerName || detail.playerId }}, Hole {{ detail.hole }}:
                                                                  {{ detail.shotsSubmitted }} shots submitted, {{ detail.shotsInHole }} in hole (Status: {{ detail.statusCode }})
                                                                </li>
                                                              }
                                                            </ul>
                                                          </div>
                                                        }
                                                      </div>
                                                    }
                                                  </div>
                                                }
                                              </div>
                                            }

                                            <!-- History Tab -->
                                            @if (activeTab() === 'history') {
                                              <div>
                                                <div class="ibox">
                                                  <div class="ibox-title">
                                                    <h3>Execution History</h3>
                                                    <div class="ibox-tools">
                                                      <button
                                                        class="btn btn-sm btn-primary"
                                                        (click)="refreshExecutionHistory()"
                                                        [disabled]="simulatorStatus() !== 'online'"
                                                        >
                                                        <i class="fa fa-refresh"></i> Refresh
                                                      </button>
                                                    </div>
                                                  </div>
                                                  <div class="ibox-content">
                                                    @if (executionHistory().length === 0) {
                                                      <div
                                                        class="alert alert-info"
                                                        >
                                                        <i class="fa fa-info-circle"></i>
                                                        No executions found. Execute a simulation definition to see
                                                        history.
                                                      </div>
                                                    }
                                                    @if (executionHistory().length > 0) {
                                                      <div
                                                        class="table-responsive"
                                                        >
                                                        <table class="table table-striped table-hover">
                                                          <thead>
                                                            <tr>
                                                              <th>Definition</th>
                                                              <th>Status</th>
                                                              <th>Valid</th>
                                                              <th>Started</th>
                                                              <th>Completed</th>
                                                              <th>Actions</th>
                                                            </tr>
                                                          </thead>
                                                          <tbody>
                                                            @for (execution of executionHistory(); track execution) {
                                                              <tr>
                                                                <td>
                                                                  <strong>{{
                                                                    getDefinitionName(execution.definitionId)
                                                                  }}</strong>
                                                                </td>
                                                                <td>
                                                                  <span
                                                                    class="label"
                                                                    [ngClass]="getStatusClass(execution.status)"
                                                                    >
                                                                    <i
                                                                      class="fa"
                                                                      [ngClass]="getStatusIcon(execution.status)"
                                                                    ></i>
                                                                    {{ execution.status }}
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  @if (execution.roundValidationStatus) {
                                                                    <span
                                                                      class="label"
                                                                      [class.label-success]="execution.roundValidationStatus === 'Valid'"
                                                                      [class.label-danger]="execution.roundValidationStatus === 'Invalid'"
                                                                      [class.label-default]="execution.roundValidationStatus === 'NotValidated'"
                                                                      >
                                                                      <i class="fa" [class.fa-check]="execution.roundValidationStatus === 'Valid'" [class.fa-times]="execution.roundValidationStatus === 'Invalid'" [class.fa-question]="execution.roundValidationStatus === 'NotValidated'"></i>
                                                                      {{ execution.roundValidationStatus === 'NotValidated' ? '-' : execution.roundValidationStatus }}
                                                                    </span>
                                                                  }
                                                                  @if (!execution.roundValidationStatus) {
                                                                    <span class="text-muted">-</span>
                                                                  }
                                                                </td>
                                                                <td>
                                                                  <small>{{
                                                                    formatLocalTime(execution.startedAt)
                                                                  }}</small>
                                                                </td>
                                                                <td>
                                                                  <small>
                                                                    {{
                                                                    execution.completedAt
                                                                    ? formatLocalTime(execution.completedAt)
                                                                    : "-"
                                                                    }}
                                                                  </small>
                                                                </td>
                                                                <td>
                                                                  <button
                                                                    class="btn btn-xs btn-primary"
                                                                    (click)="viewExecutionSummary(execution.id)"
                            [disabled]="
                              execution.status === 'Pending' ||
                              execution.status === 'Running'
                            "
                                                                    title="View Summary"
                                                                    >
                                                                    <i class="fa fa-file-text-o"></i>
                                                                  </button>
                                                                  <button
                                                                    class="btn btn-xs btn-info ms-2"
                                                                    (click)="validateExecutionRound(execution.id, execution.currentRound || 1)"
                            [disabled]="
                              execution.status === 'Pending' ||
                              execution.status === 'Running'
                            "
                                                                    title="Validate Round (includes legacy replay comparison when available)"
                                                                    >
                                                                    <i class="fa fa-check-circle"></i>
                                                                  </button>
                                                                </td>
                                                              </tr>
                                                            }
                                                          </tbody>
                                                        </table>
                                                      </div>
                                                    }
                                                  </div>
                                                </div>
                                              </div>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <!-- Execution Summary Modal -->
                                  <div
                                    class="modal summary-modal"
                                    [class.show]="isSummaryModalOpen()"
                                    [style.display]="isSummaryModalOpen() ? 'block' : 'none'"
                                    tabindex="-1"
                                    role="dialog"
                                    (keydown.escape)="closeSummaryModal()"
                                    >
                                    <div class="modal-dialog modal-dialog-wide" role="document">
                                      <div class="modal-content summary-modal-content">
                                        <!-- Modal Header with Title and Status -->
                                        <div class="modal-header summary-modal-header">
                                          <div class="summary-header-left">
                                            <h5 class="modal-title">
                                              <i class="fa fa-file-text-o"></i> Execution Summary
                                            </h5>
                                            @if (executionSummary(); as summary) {
                                              <div
                                                class="summary-header-subtitle"
                                                >
                                                <span class="summary-name">{{ summary.definitionName }}</span>
                                                <span class="summary-separator"> | </span>
                                                <span class="summary-timestamp">{{
                                                  formatLocalTime(summary.generatedAt)
                                                }}</span>
                                              </div>
                                            }
                                          </div>
                                        </div>

                                        <div class="modal-body summary-modal-body">
                                          <!-- Loading State -->
                                          @if (summaryLoading()) {
                                            <div class="summary-loading">
                                              <div class="spinner-center">
                                                <i class="fa fa-spinner fa-spin fa-3x text-muted"></i>
                                                <p class="text-muted mt-3">Loading summary...</p>
                                              </div>
                                            </div>
                                          }

                                          <!-- Error State -->
                                          @if (summaryError()) {
                                            <div
                                              class="alert alert-danger alert-dismissible fade show"
                                              role="alert"
                                              >
                                              <i class="fa fa-exclamation-circle"></i>
                                              <strong>Error:</strong> {{ summaryError() }}
                                              <button
                                                type="button"
                                                class="btn-close"
                                                (click)="closeSummaryModal()"
                                              ></button>
                                            </div>
                                          }

                                          <!-- Summary Content -->
                                          @if (executionSummary(); as summary) {
                                            <!-- Header Card with Status -->
                                            <div class="summary-header-card">
                                              <div class="header-card-content">
                                                <div class="header-left">
                                                  <h6 class="header-subtitle">Execution Details</h6>
                                                  <div class="header-details">
                                                    <div class="detail-row">
                                                      <span class="detail-label">ID:</span>
                                                      <code class="detail-value">{{ summary.executionId }}</code>
                                                    </div>
                                                    <div class="detail-row">
                                                      <span class="detail-label">Environment:</span>
                                                      <span class="detail-value">{{
                                                        summary.metadata.targetEnvironment
                                                      }}</span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <!-- Key Metrics Grid -->
                                            <div class="metrics-grid summary-metrics">
                                              <div class="metric-card metric-completion">
                                                <div class="metric-icon">
                                                  <i class="fa fa-percent"></i>
                                                </div>
                                                <div class="metric-content">
                                                  <div class="metric-label">Completion</div>
                                                  <div class="metric-value">
                                                    {{ summary.results.completionPercentage | number : "1.0-1" }}%
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="metric-card metric-scores">
                                                <div class="metric-icon">
                                                  <i class="fa fa-list-ul"></i>
                                                </div>
                                                <div class="metric-content">
                                                  <div class="metric-label">Scores</div>
                                                  <div class="metric-value">
                                                    {{ summary.results.totalScoresSubmitted
                                                    }}<span class="metric-total"
                                                    >/{{ summary.results.totalScoresExpected || "?" }}</span
                                                    >
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="metric-card metric-shots">
                                                <div class="metric-icon">
                                                  <i class="fa fa-golf-course"></i>
                                                </div>
                                                <div class="metric-content">
                                                  <div class="metric-label">Shots</div>
                                                  <div class="metric-value">
                                                    {{ summary.results.totalShotsSubmitted
                                                    }}<span class="metric-total"
                                                    >/{{ summary.results.totalShotsExpected || "?" }}</span
                                                    >
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="metric-card metric-groups">
                                                <div class="metric-icon">
                                                  <i class="fa fa-users"></i>
                                                </div>
                                                <div class="metric-content">
                                                  <div class="metric-label">Groups</div>
                                                  <div class="metric-value">
                                                    {{ summary.results.groupsCompleted
                                                    }}<span class="metric-total"
                                                    >/{{ summary.results.groupsExpected }}</span
                                                    >
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <!-- Round-by-Round Breakdown (Full Width Section) -->
                                            @if (summary.rounds && summary.rounds.length > 0) {
                                              <div
                                                class="round-breakdown-section"
                                                >
                                                <h6 class="section-title">Round-by-Round Breakdown</h6>
                                                <div class="table-responsive round-breakdown-table">
                                                  <table class="table table-striped table-sm mb-0">
                                                    <thead>
                                                      <tr>
                                                        <th>Round</th>
                                                        <th>Duration</th>
                                                        <th>Started</th>
                                                        <th>Completed</th>
                                                        <th>Groups</th>
                                                        <th>Scores</th>
                                                        <th>Shots</th>
                                                        <th class="progress-col">Progress</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      @for (round of summary.rounds; track round) {
                                                        <tr
                    [class.highlighted-round]="
                      isCurrentRound(round.roundNumber, summary)
                    "
                                                          >
                                                          <td class="round-cell">
                                                            <strong>Round {{ round.roundNumber }}</strong>
                                                          </td>
                                                          <td class="duration-cell">
                                                            <span class="badge bg-info">{{
                                                              formatDurationTimeSpan(round.duration)
                                                            }}</span>
                                                          </td>
                                                          <td class="timestamp-cell">
                                                            @if (round.startedAt) {
                                                              <small>{{
                                                                formatLocalTime(round.startedAt)
                                                              }}</small>
                                                            }
                                                            @if (!round.startedAt) {
                                                              <small class="text-muted"
                                                                >—</small
                                                                >
                                                            }
                                                          </td>
                                                          <td class="timestamp-cell">
                                                            @if (round.completedAt) {
                                                              <small>{{
                                                                formatLocalTime(round.completedAt)
                                                              }}</small>
                                                            }
                                                            @if (!round.completedAt) {
                                                              <small class="text-muted"
                                                                >—</small
                                                                >
                                                              }
                                                            </td>
                                                            <td class="metric-cell">
                                                              <small
                                                                >{{ round.groupsProcessed }}/{{
                                                                round.groupsExpected
                                                                }}</small
                                                                >
                                                              </td>
                                                              <td class="metric-cell">
                                                                <small
                                                                  >{{ round.scoresSubmitted }}/{{
                                                                  round.scoresExpected
                                                                  }}</small
                                                                  >
                                                                </td>
                                                                <td class="metric-cell">
                                                                  <small
                                                                    >{{ round.shotsSubmitted }}/{{
                                                                    round.shotsExpected
                                                                    }}</small
                                                                    >
                                                                  </td>
                                                                  <td class="progress-cell">
                                                                    <strong
                                                                      >{{
                                                                      round.completionPercentage | number : "1.0-0"
                                                                      }}%</strong
                                                                      >
                                                                    </td>
                                                                  </tr>
                                                                }
                                                              </tbody>
                                                            </table>
                                                          </div>
                                                        </div>
                                                      }
                                                    }
                                                  </div>

                                                  <!-- Modal Footer -->
                                                  <div class="modal-footer summary-modal-footer">
                                                    <button
                                                      type="button"
                                                      class="btn btn-primary"
                                                      (click)="closeSummaryModal()"
                                                      >
                                                      <i class="fa fa-check"></i> Close
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                            <!-- Modal Backdrop -->
                                            <div
                                              class="modal-backdrop fade"
                                              [class.show]="isSummaryModalOpen()"
                                              [style.display]="isSummaryModalOpen() ? 'block' : 'none'"
                                            ></div>

                                            <!-- Execute Simulation Modal -->
                                            <div
                                              class="modal"
                                              [class.show]="isExecuteModalOpen()"
                                              [style.display]="isExecuteModalOpen() ? 'block' : 'none'"
                                              tabindex="-1"
                                              role="dialog"
                                              >
                                              <div class="modal-dialog" role="document">
                                                <div class="modal-content">
                                                  <div class="modal-header">
                                                    <h5 class="modal-title">
                                                      {{ isDryRunMode() ? "Dry Run" : "Execute Simulation" }}
                                                    </h5>
                                                    <button
                                                      type="button"
                                                      class="close"
                                                      (click)="closeExecuteModal()"
                                                      aria-label="Close"
                                                      >
                                                      <span aria-hidden="true">&times;</span>
                                                    </button>
                                                  </div>
                                                  <div class="modal-body">
                                                    <div class="form-group">
                                                      <label for="startRound">Start at Round:</label>
                                                      <select
                                                        id="startRound"
                                                        class="form-control"
                                                        [ngModel]="executeStartRound()"
                                                        (ngModelChange)="executeStartRound.set($event)"
                                                        >
                                                        @for (roundNum of availableRoundNumbers(); track roundNum) {
                                                          <option
                                                            [ngValue]="roundNum"
                                                            >
                                                            Round {{ roundNum }}
                                                          </option>
                                                        }
                                                      </select>
                                                      @if (availableRoundNumbers().length === 0) {
                                                        <small
                                                          class="form-text text-muted"
                                                          >
                                                          No rounds available for the active tournament
                                                        </small>
                                                      }
                                                      @if (availableRoundNumbers().length > 0) {
                                                        <small
                                                          class="form-text text-muted"
                                                          >
                                                          Select the round number to
                                                          {{ isDryRunMode() ? "validate" : "start execution" }}
                                                        </small>
                                                      }
                                                    </div>
                                                  </div>
                                                  <div class="modal-footer">
                                                    <button
                                                      type="button"
                                                      class="btn btn-secondary"
                                                      (click)="closeExecuteModal()"
                                                      >
                                                      Cancel
                                                    </button>
                                                    @if (!isDryRunMode()) {
                                                      <button
                                                        type="button"
                                                        class="btn btn-success"
                                                        (click)="confirmExecution()"
                                                        >
                                                        <i class="fa fa-play"></i> Execute
                                                      </button>
                                                    }
                                                    @if (isDryRunMode()) {
                                                      <button
                                                        type="button"
                                                        class="btn btn-info"
                                                        (click)="confirmDryRun()"
                                                        >
                                                        <i class="fa fa-flask"></i> Run Dry Run
                                                      </button>
                                                    }
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              class="modal-backdrop fade"
                                              [class.show]="isExecuteModalOpen()"
                                              [style.display]="isExecuteModalOpen() ? 'block' : 'none'"
                                            ></div>

                                            <!-- Validation Modal -->
                                            <div
                                              class="modal validation-modal"
                                              [class.show]="isValidationModalOpen()"
                                              [style.display]="isValidationModalOpen() ? 'block' : 'none'"
                                              tabindex="-1"
                                              role="dialog"
                                              (keydown.escape)="closeValidationModal()"
                                              >
                                              <div class="modal-dialog modal-lg" role="document">
                                                <div class="modal-content">
                                                  <div class="modal-header" [ngClass]="validationResult()?.isValid ? 'bg-success text-white' : 'bg-warning text-dark'">
                                                    <h5 class="modal-title">
                                                      <i [class]="validationResult()?.isValid ? 'fa fa-check-circle' : 'fa fa-exclamation-triangle'"></i>
                                                      Round Validation Results
                                                    </h5>
                                                    <button
                                                      type="button"
                                                      class="close"
                                                      (click)="closeValidationModal()"
                                                      aria-label="Close"
                                                      >
                                                      <span aria-hidden="true">&times;</span>
                                                    </button>
                                                  </div>
                                                  <div class="modal-body">
                                                    @if (validationResult()) {
                                                      <div>
                                                        <!-- Overall Status -->
                                                        <div class="alert" [ngClass]="validationResult()?.isValid ? 'alert-success' : 'alert-warning'">
                                                          <strong>{{ validationResult()?.isValid ? 'Validation Passed' : 'Validation Failed' }}</strong>
                                                          <p class="mb-0">{{ validationResult()?.validationMessage }}</p>
                                                        </div>
                                                        <!-- Incomplete Scores Section -->
                                                        <div class="card mb-3">
                                                          <div class="card-header">
                                                            <h6 class="mb-0">
                                                              <i class="fa fa-list-ol"></i> Score Completion Status
                                                            </h6>
                                                          </div>
                                                          <div class="card-body">
                                                            <div class="row">
                                                              <div class="col-md-4">
                                                                <div class="stat-box">
                                                                  <div class="stat-label">Total Scores</div>
                                                                  <div class="stat-value">{{ validationResult()?.totalScores || 0 }}</div>
                                                                </div>
                                                              </div>
                                                              <div class="col-md-4">
                                                                <div class="stat-box text-success">
                                                                  <div class="stat-label">Complete</div>
                                                                  <div class="stat-value">{{ validationResult()?.completeScores || 0 }}</div>
                                                                </div>
                                                              </div>
                                                              <div class="col-md-4">
                                                                <div class="stat-box" [ngClass]="(validationResult()?.incompleteScores || 0) > 0 ? 'text-warning' : 'text-muted'">
                                                                  <div class="stat-label">Incomplete</div>
                                                                  <div class="stat-value">{{ validationResult()?.incompleteScores || 0 }}</div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <!-- Incomplete Score Details -->
                                                            @if ((validationResult()?.incompleteScoreDetails?.length || 0) > 0) {
                                                              <div class="mt-3">
                                                                <h6 class="text-warning">
                                                                  <i class="fa fa-exclamation-circle"></i> Incomplete Score Details
                                                                </h6>
                                                                <div class="table-responsive" style="max-height: 200px; overflow-y: auto;">
                                                                  <table class="table table-sm table-striped">
                                                                    <thead class="thead-light">
                                                                      <tr>
                                                                        <th>Player</th>
                                                                        <th>Hole</th>
                                                                        <th>Status</th>
                                                                        <th>Shots Submitted</th>
                                                                        <th>Expected Shots</th>
                                                                      </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                      @for (detail of validationResult()?.incompleteScoreDetails; track detail) {
                                                                        <tr>
                                                                          <td>{{ detail.playerName || 'Player ' + detail.playerId }}</td>
                                                                          <td>{{ detail.hole }}</td>
                                                                          <td><span class="badge badge-warning">{{ detail.statusCode }}</span></td>
                                                                          <td>{{ detail.shotsSubmitted }}</td>
                                                                          <td>{{ detail.shotsInHole }}</td>
                                                                        </tr>
                                                                      }
                                                                    </tbody>
                                                                  </table>
                                                                </div>
                                                              </div>
                                                            }
                                                          </div>
                                                        </div>
                                                        <!-- Legacy Replay Comparison Section -->
                                                        @if (validationResult()?.legacyReplayComparison) {
                                                          <div class="card mb-3">
                                                            <div class="card-header">
                                                              <h6 class="mb-0">
                                                                <i class="fa fa-balance-scale"></i> Legacy Replay Comparison
                                                              </h6>
                                                            </div>
                                                            <div class="card-body">
                                                              <div class="alert" [ngClass]="validationResult()?.legacyReplayComparison?.isValid ? 'alert-success' : 'alert-danger'">
                                                                <strong>{{ validationResult()?.legacyReplayComparison?.isValid ? 'Data Matches' : 'Data Mismatch Detected' }}</strong>
                                                                <p class="mb-0">{{ validationResult()?.legacyReplayComparison?.validationMessage }}</p>
                                                              </div>
                                                              <div class="row mb-3">
                                                                <div class="col-md-6">
                                                                  <div class="stat-box">
                                                                    <div class="stat-label">Players Compared</div>
                                                                    <div class="stat-value">{{ validationResult()?.legacyReplayComparison?.totalPlayersCompared || 0 }}</div>
                                                                  </div>
                                                                </div>
                                                                <div class="col-md-6">
                                                                  <div class="stat-box" [ngClass]="(validationResult()?.legacyReplayComparison?.playersWithDiscrepancies || 0) > 0 ? 'text-danger' : 'text-success'">
                                                                    <div class="stat-label">Players with Discrepancies</div>
                                                                    <div class="stat-value">{{ validationResult()?.legacyReplayComparison?.playersWithDiscrepancies || 0 }}</div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              <!-- Legacy vs vNext Counts Comparison -->
                                                              <div class="row">
                                                                <div class="col-md-6">
                                                                  <h6 class="text-muted">Legacy Database</h6>
                                                                  <ul class="list-unstyled">
                                                                    <li><strong>Total Scores:</strong> {{ validationResult()?.legacyReplayComparison?.legacyCounts?.totalScores || 0 }}</li>
                                                                    <li><strong>Total Shots:</strong> {{ validationResult()?.legacyReplayComparison?.legacyCounts?.totalShots || 0 }}</li>
                                                                    <li><strong>Complete Scores:</strong> {{ validationResult()?.legacyReplayComparison?.legacyCounts?.completeScores || 0 }}</li>
                                                                    <li><strong>Incomplete Scores:</strong> {{ validationResult()?.legacyReplayComparison?.legacyCounts?.incompleteScores || 0 }}</li>
                                                                  </ul>
                                                                </div>
                                                                <div class="col-md-6">
                                                                  <h6 class="text-primary">vNext Database</h6>
                                                                  <ul class="list-unstyled">
                                                                    <li><strong>Total Scores:</strong> {{ validationResult()?.legacyReplayComparison?.vNextCounts?.totalScores || 0 }}</li>
                                                                    <li><strong>Total Shots:</strong> {{ validationResult()?.legacyReplayComparison?.vNextCounts?.totalShots || 0 }}</li>
                                                                    <li><strong>Complete Scores:</strong> {{ validationResult()?.legacyReplayComparison?.vNextCounts?.completeScores || 0 }}</li>
                                                                    <li><strong>Incomplete Scores:</strong> {{ validationResult()?.legacyReplayComparison?.vNextCounts?.incompleteScores || 0 }}</li>
                                                                  </ul>
                                                                </div>
                                                              </div>
                                                              <!-- Player Discrepancies -->
                                                              @if ((validationResult()?.legacyReplayComparison?.playerDiscrepancies?.length || 0) > 0) {
                                                                <div class="mt-3">
                                                                  <h6 class="text-danger">
                                                                    <i class="fa fa-exclamation-circle"></i> Player Discrepancies Found
                                                                  </h6>
                                                                  <div class="alert alert-info">
                                                                    <small>{{ validationResult()?.legacyReplayComparison?.playerDiscrepancies?.length }} player(s) have differences. Check console or use Compare Legacy Replay endpoint for detailed hole-by-hole analysis.</small>
                                                                  </div>
                                                                </div>
                                                              }
                                                            </div>
                                                          </div>
                                                        }
                                                      </div>
                                                    }
                                                  </div>
                                                  <div class="modal-footer">
                                                    <button
                                                      type="button"
                                                      class="btn btn-secondary"
                                                      (click)="closeValidationModal()"
                                                      >
                                                      Close
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              class="modal-backdrop validation-backdrop"
                                              [class.show]="isValidationModalOpen()"
                                              [style.display]="isValidationModalOpen() ? 'block' : 'none'"
                                            ></div>
